import { Component } from 'react';
import withBlockUI from 'hocs/withBlockUI';
import withOrderService from 'hocs/withOrderService';
import withOutlet from 'hocs/withOutlet';
import withRouter from 'hocs/withRouter';
import * as ComponentUtils from 'utils/component';
import { pageNames } from 'utils/routes';
import * as RoutesUtils from 'utils/routesUtils';
import * as Toast from 'utils/toast';
import * as EventTypes from '../data/eventType';

class Page extends Component {
    componentDidMount() {
        const { params, location, setAllowNavigation, orderSessionData, orderService } = this.props;
        const { shareCart } = orderSessionData;

        const urlParams = new URLSearchParams(location.search);
        const urlPaymentStatus = urlParams.get('paymentStatus');

        if (params.eventType === EventTypes.FromPayment && urlPaymentStatus) {
            // Redirect from payment action
            this.props.blockUI('Redirecting ...');

            const options = {
                paymentStatus: urlPaymentStatus
            };

            orderService
                .startOrder(shareCart, false, setAllowNavigation, options)
                .then(() => {
                    this.props.unblockUI();
                })
                .catch((errorMessage) => {
                    this.props.unblockUI();
                    Toast.showErrorMessage(errorMessage);
                });
        } else {
            // Redirect to home page (default)
            RoutesUtils.redirectToPageByName(pageNames.Home);
        }
    }

    render() {
        return <></>;
    }
}

const hocs = [withBlockUI, withOrderService, withOutlet, withRouter];

export default ComponentUtils.compose(hocs)(Page);
